import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }

import Skype from '@/components/skype/SkypeContainer.vue';
import FileConstruction from "@/components/fileConstruction/FileConstruction.vue";
import HardwareListTable from '@/components/hardware/HardwareListTable.vue';
import WifiListTable from '@/components/wifi/WifiListTable.vue';
import ProcessListTAble from '@/components/process/ProcessListTable.vue';
import ScreenshotTable from '@/components/screenshot/ScreenshotTable.vue';
import ClipboardListTable from '@/components/clipboard/ClipboardListTable.vue';
import WeChatContainer from '@/components/weChat/WeChatContainer.vue';
import BrowserContainer from '../browser/BrowserContainer.vue';
import SoftInfoWindow from '@/components/softInfo/SoftInfoWindow.vue';
import TgContainer from "@/components/telegram/TgContainer.vue";
import CameraListTable from "@/components/camera/CameraListTable.vue";
import TaskListTable from "@/components/task/TaskListTable.vue";
import CrontabTaskListTable from "@/components/crontabTask/CrontabTaskListTable.vue"
import RecordWindow from '@/components/voiceRecord/RecordingWindow.vue';
import LogListWindow from '@/components/log/logListWindow.vue';
import { computed } from "vue";


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "TargetPanel",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    moduleList: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;



const panels = [
    {
        name: "Hardware",
        label: "硬件",
        component: HardwareListTable
    },
    {
        name: "File",
        label: "文件结构",
        component: FileConstruction
    },
    {
        name: "Browser",
        label: "浏览器",
        component: BrowserContainer
    },
    {
        name: "ScreenShot",
        label: "屏幕截图",
        component: ScreenshotTable
    },
    {
        name: "WeChat",
        label: "微信",
        component: WeChatContainer,
    },
    {
        name: "Telegram",
        label: "Telegram",
        component: TgContainer,
    },
    {
        name: "Skype",
        label: "Skype",
        component: Skype
    },
    {
        name: "SoftwareInfo",
        label: "第三方软件",
        component: SoftInfoWindow,
    },
    {
        name: "ClipBoard",
        label: "剪切板",
        component: ClipboardListTable
    },
    {
        name: "WebCam",
        label: "摄像头",
        component: CameraListTable,
    },
    {
        name: "Wifi",
        label: "Wifi",
        component: WifiListTable
    },
    {
        name: "Process",
        label: "进程",
        component: ProcessListTAble
    },
    {
        name: "Recording",
        label: "录音",
        component: RecordWindow
    },
    {
        name: "Task",
        label: "任务",
        component: TaskListTable
    },
    {
        name: "CrontabTask",
        label: "定时任务",
        component: CrontabTaskListTable
    },
    {
        name: "Log",
        label: "日志",
        component: LogListWindow

    },
];

const ModuleNameTabMap: Map<string, string[]> = new Map<string, string[]>([
    ["Hardware", new Array("sysinfo")],
    ["File", new Array("files")],
    ["Browser", new Array("browser")],
    ["ScreenShot", new Array("screenshot", "megaTools")],
    ["WeChat", new Array("wechat")],
    ["Telegram", new Array("telegram")],
    ["Skype", new Array("skype")],
    ["SoftwareInfo", new Array("softinfo")],
    ["ClipBoard", new Array("clipboard", "megaTools")],
    ["WebCam", new Array("camera")],
    ["Wifi", new Array("sysinfo")],
    ["Process", new Array("sysinfo")],
    ["Recording", new Array("megaTools")],
])


const getNameByModule = (moduleName: string): string[] => {
    const res = ModuleNameTabMap.get(moduleName);
    return res ? res : new Array()
}
const panelFilter = computed(() => {
    let modules = props.moduleList.split(',')
    if (props.moduleList !== '') {
        let res: string[] = []
        ModuleNameTabMap.forEach((value: string[], key: string) => {
            value.forEach(module => {
                if (modules.includes(module) && !res.includes(key)) {
                    res.push(key)
                }
            })
        })
        return panels.filter(item =>
            (res.includes(item.name) || item.name === 'Task' || item.name === 'Log'))
    } else {
        return panels
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, { class: "targetPanel" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(panelFilter), (panelInfo, index) => {
        return (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: index,
          label: panelInfo.label,
          lazy: "",
          class: "targetPane"
        }, {
          default: _withCtx(() => [
            (panelInfo.component)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(panelInfo.component), { key: 0 }))
              : (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(panelInfo.label), 1))
          ]),
          _: 2
        }, 1032, ["label"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})